export default [
    {
        key: "forwardhead",
        name: "Przechylenie głowy do przodu",
        definition: {
            name: "Definicja",
            list: ["Przechylenie głowy do przodu oznacza, że gdy ludzkie ciało jest w naturalnej pozycji stojącej lub siedzącej, głowa jest w nienormalnie pochylonej do przodu pozycji względem tułowia. Jest to częste u długo siedzących uczniów i osób pracujących w biurze."]
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Długotrwałe pochylone pozycje podczas pracy. Gdy ktoś pracuje przed komputerem przez długi czas, głowa zwykle wysuwa się do przodu.",
                "2. Przyzwyczajenie do pochylania głowy, aby spojrzeć na telefon komórkowy. Spoglądanie na telefon z pochyloną głową, czyli tak zwana ‘plemiona pochylonych głów’, jest również jednym z głównych czynników wywołujących przechylenie głowy do przodu.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Zawroty głowy i bóle głowy: Przechylenie głowy do przodu może wpłynąć na przepływ krwi w głowie. Z powodu złego przepływu krwi występuje niedobór tlenu w głowie, co powoduje zawroty głowy i bóle głowy.",
                "2. Choroby szyi: Ze względu na nienormalną pozycję głowy występują nieprawidłowości w tkankach miękkich i kościach szyi, zwiększając ryzyko chorób szyi.",
                "3. Choroby sercowo-naczyniowe i mózgowo-naczyniowe: Nienormalna pozycja głowy może wpłynąć na przepływ krwi w głowie i zaszkodzić zdrowiu układu sercowo-naczyniowego i mózgowo-naczyniowego.",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "Skoszenie głowy na bok",
        definition: {
            name: "Definicja",
            list: ["Skoszenie głowy na bok oznacza nienormalną postawę, gdy głowa jest nadmiernie przechylona na bok, gdy ludzkie ciało jest w naturalnej pozycji stojącej lub siedzącej. Główną przyczyną jest nierównowaga siły mięśni szyi i ramion po obu stronach, często spowodowana nawykowymi złymi postawami."]
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Przyzwyczajenie do używania mięśni szyi i ramienia z jednej strony: Kiedy siedzimy lub leżymy, szyja często jest skłonna tylko w jedną stronę, powodując nierównowagę siły mięśni szyi i ramion po obu stronach.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Chroniczne przeciążenie mięśni i więzadeł: Długotrwałe skoszenie głowy może łatwo prowadzić do chronicznego przeciążenia tylnych więzadeł szyi oraz więzadeł i mięśni.",
                "2. Choroby szyi: Ze względu na nienormalną pozycję głowy występują nieprawidłowości w tkankach miękkich i kościach szyi, zwiększając ryzyko chorób szyi.",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "nierówne ramiona",
        definition: {
            name: "Definicja",
            list: ["nierówne ramiona odnosi się do sytuacji, w której ramiona po obu stronach mają różne wysokości w pionie, gdy ciało człowieka jest w naturalnym stanie rozluźnienia. Zazwyczaj nierówne ramiona są verbunden z anomaliami w postawie kręgosłupa."]
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Nadmierne obciążenie po jednej stronie: na przykład noszenie plecaka lub ciężkich przedmiotów po jednej stronie przez długi czas.",
                "2. Długotrwała zła postawa: Spowodowana złymi nawykami, takimi jak siedzenie ze skrzyżowanymi nogami przez długi czas lub nachylanie się nad stołem podczas pracy pochylonej.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Ból pleców: (nierówne ramiona) mogą powodować przemieszczenie miednicy, co prowadzi do nierównowagi siły mięśni po obu stronach talii i powoduje ból pleców.",
                "2. Osteofit: Nierówne ramiona powodują anormalne obciążenie kręgosłupa szyjnego i ostatecznie mogą prowadzić do degeneracji obszaru kręgosłupa szyjnego i łatwo tworzyć się osteofity.",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "okrągłe ramiona",
        definition: {
            name: "Definicja",
            list: ["Zaokrąglone ramiona odnoszą się do stanu, w którym ramiona wyglądają na zagięte do przodu i do środka, gdy obserwuje się je z boku. Często towarzyszy im garb. Często występuje u uczniów i osób pracujących w biurach."],
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Zła postawa nawykowa: np. garbienie się, nieregularne leżenie na boku itp.",
                "2. Nierównowaga sił mięśniowych w klatce piersiowej i plecach: Mięśnie piersiowe są względnie słabsze w porównaniu z mięśniami pleców.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Zwiększone obciążenie serca: Nadmiernie zaokrąglone ramiona spowodują napięcie przepony, co spowoduje ucisk aorty i żyły głównej dolnej i zwiększy obciążenie pracy serca.",
                "2. Skompresowane nerwy: Napięcie mięśni wokół ramion i szyi może w ciężkich przypadkach doprowadzić do kompresji nerwów kręgosłupa szyjnego, powodując bóle głowy i drętwienie ręki.",
            ],
        }
    },
    {
        name: "skolioza kręgosłupa",
        key: "scoliosis",
        definition: {
            name: "Definicja",
            list: ["Występują anomalie w pozycji kręgosłupa. Poprzez badania obrazowe można wykryć nieprawidłowe stany kręgosłupa, takie jak skolioza. Anomalie można podzielić na wrodzone i nabyte. Nabyte anomalie są związane z błędnymi nawykami postawy."],
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Nadmierne obciążenie jednostronne: na przykład noszenie plecaka lub podnoszenie ciężkich przedmiotów jednostronnie przez długi czas.",
                "2. Długotrwała zła postawa: Spowodowana złymi nawykami, takimi jak siedzenie ze skrzyżowanymi nogami przez długi czas lub nachylanie się nad stołem podczas pracy pochylonej.",
                "3. Przyczyny wrodzone: Skolioza kręgosłupa spowodowana czynnikami wrodzonymi.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Wypuklina dysku lędźwiowego.",
                "2. Ból pleców: Może powodować przemieszczenie miednicy, co prowadzi do nierównowagi siły mięśniowej po obu stronach talii i powoduje ból pleców.",
                "3. Nogi o różnej długości.",
            ],
        }
    },
    {
        name: "boczne nachylenie miednicy",
        key: "unevenhip",
        definition: {
            name: "Definicja",
            list: ["Boczne nachylenie miednicy odnosi się do stanu, w którym wysokość bioder po obu stronach jest znacznie różna, prezentując stan nachylenia miednicy. Często towarzyszy mu anomalia położenia kręgosłupa i nierówne ramiona."],
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Długotrwała zła postura: Spowodowana złymi nawykami, takimi jak siedzenie ze skrzyżowanymi nogami przez długi czas lub nachylanie się nad stołem podczas pracy pochylonej.",
                "2. Wrodzone różnej długości nogi: Boczne nachylenie miednicy spowodowane wrodzoną różnicą długości nóg.",
                "3. Nierównowaga posturalna kończyn dolnych po obu stronach: na przykład jeden stopień ma płaskostopie, a drugi nie lub stopień jest różny; obie strony mają hiperrozciągnięcie kolana, ale stopień jest różny.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Wypuklina dysku lędźwiowego.",
                "2. Chroniczny ból: Boczne nachylenie miednicy może powodować ból w nogach i tali, a także w szyi i ramionach.",
                "3. Nogi o różnej długości.",
            ],
        }
    },
    {
        name: "nogi w kształcie litery O",
        key: "oleg",
        definition: {
            name: "Definicja",
            list: ["Kiedy osoba stoi w normalnej postawie i stopy są złączone, wewnętrzne kostki mogą przylegać do siebie, ale wewnętrzne kolana nie mogą i może być nawet duża szczelina między nimi. Między nogami pojawia się kształt \"O\". Ten rodzaj kształtu nóg jest związany z codziennymi nawykami postawy. Pojawienie się nóg w kształcie \"O\" u dzieci może być również związane z krzywicą."],
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Złe nawyki posturalne, takie jak: odchylenie miednicy do tyłu i tendencja do pronacji stopy.",
                "2. Nierównowaga siły mięśniowej, np. zbyt napięte mięśnie zewnętrzne rotatory bioder.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Uszkodzenie łąkotki przyśrodkowej: Nogi w kształcie litery O powodują zmiany w linii siły kończyn dolnych. Przestrzeń przyśrodkowa stawu kolanowego jest poddana większemu naciskowi niż normalne obciążenie. Może to spowodować uszkodzenie łąkotki przyśrodkowej stawu kolanowego.",
                "2. Zapalenie stawów: W ciężkich przypadkach (nogi w kształcie litery O) może ostatecznie rozwinąć się osteoartroza stawu kolanowego i zwyrodnienie stawu w przestrzeni stawowej bocznej. W ciężkich przypadkach może być konieczna operacja wymiany sztucznego stawu.",
            ],
        }
    },
    {
        name: "nogi w kształcie litery X",
        key: "xleg",
        definition: {
            name: "Definicja",
            list: "Kiedy człowiek stoi w normalnej postawie i nogi są złączone, wewnętrzne kolana mogą być blisko siebie, ale wewnętrzne strony kostek nie mogą być blisko siebie i może być nawet duża szczelina. Kształt między nogami jest jak litera \"X\". Ten rodzaj kształtu nóg jest związany z codziennymi nawykami postawy i nierównowagą mięśniową.",
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Niewłaściwe postawy nawykowe, takie jak: pochylenie miednicy do przodu, tendencja do pronacji stopy.",
                "2. Nierównowaga siły mięśniowej, np. zbyt napięte mięśnie rotacji wewnętrznej biodra.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Uszkodzenie łąkotki bocznej: Nogi w kształcie litery X powodują zmiany w linii siły kończyn dolnych. Przestrzeń boczna stawu kolanowego jest poddana większemu naciskowi niż normalne obciążenie. Może to spowodować uszkodzenie łąkotki bocznej stawu kolanowego.",
                "2. Zapalenie stawów: W ciężkich przypadkach (nogi w kształcie litery X) może ostatecznie rozwinąć się osteoartroza stawu kolanowego i zwyrodnienie stawu w przestrzeni stawowej bocznej. W ciężkich przypadkach może być konieczna operacja wymiany sztucznego stawu.",
            ],
        }
    },
    {
        name: "hiperestezja kolana",
        key: "kneehyperextension",
        definition: {
            name: "Definicja",
            list: ["Hiperestezja kolana, znana również jako „odwrócony łuk kolana. Z boku ludzkiego ciała widać, że noga jest wygięta do tyłu, koleno jest wklęsłe do środka, a łydka jest nadmiernie wysunięta do przodu w porównaniu z udem. Ten typ postawy jest często spotykany u baletnic i osób z osłabioną siłą mięśni uda."],
        },
        triggerreason: {
            name: "Przyczyny",
            list: [
                "1. Nieprawidłowa postawa siłowa: stojąc, główny ciężar spada na przednią część stopy.",
                "2. Napięcie w powięzi podeszwowej: Może być spowodowane długotrwałym noszeniem wysokich obcasów.",
                "3. Słabość mięśni wokół kolana. Niedostateczna siła mięśni przedniej i tylnej części uda.",
            ]
        },
        danger: {
            name: "Ryzyko",
            list: [
                "1. Deformacja stawu kolanowego: Długotrwała hiperestezja kolana może prowadzić do znacznego wzrostu częstości występowania zwyrodnienia stawów i spowodować nadmierne zużycie stawu kolanowego, co prowadzi do deformacji stawu.",
                "2. Uszkodzenie ogólnej równowagi: Między trzema stawami: biodrem, kolanem i kostką istnieje duża powiązanie pozycyjne i funkcjonalne. Zmiana pozycji kolana wpłynie na pozycję kostki poniżej oraz pozycję bioderka i miednicy powyżej, stopniowo uszkadzając ogólną równowagę ciała. W dłuższej perspektywie może to prowadzić do różnych rodzajów bólu.",
            ],
        }
    },
]